import React, { useEffect, useMemo, useState } from 'react';
import { getLocale } from 'umi';
import moment from 'moment';
import { Col, Row } from 'tea-component';
import GameStore from '../GameStore';
import StudioTrendingVideo from '../StudioTrendingVideo';
import CommunityPerformance from '../CommunityPerformance';
import DateSelect from '@op/components/FilterCommon/widgets/DateSelect';
import { getOpinionFilterCond } from '@op/services/filter';
import useTranslateTopic from '@op/hooks/useTranslateTopic';
import OpinionHightLight from '../OpinionHightLight';
import './index.scss';
import useOpinionsFilterConfig from '../utils';

export default function OpinionsStudioV2({ gameInfo }: { gameInfo: any; }) {
  const [timeValue, setTimeValue] = useState({});
  const [isConfirm, setIsConfirm] = useState(false);
  const [isInit, setIsInit] = useState(true);
  const [filterCond, setFilterCond] = useState<any>(null);
  const { setTranslateTopicMap, translateTopicFunc } = useTranslateTopic(getLocale());

  const filter = useMemo(() => ({
    ...gameInfo,
    ...timeValue,
    isConfirm
  }), [gameInfo, timeValue]);

  // 请求筛选器数据用于Trending Publications参数处理
  useEffect(() => {
    const { edition_unified_id, entity_type, id_type } = gameInfo || {};
    getOpinionFilterCond({
      edition_unified_id,
      entity_type,
      id_type,
      request_type: ["channel", "monitor_by_account_category",'topic',],
      un_request_type: ["topic_trans"],
    }).then((res: any) => {
      setFilterCond(res || {});
      setTranslateTopicMap(res?.topic_trans);
    }).catch((err: any) => {
      console.log(err);
      setFilterCond({});
    });
  }, []);

  return (
    <div className="dbh-studio-opinions-v2 dbh-studio-opinions-v2-container">
      <div className="dbh-studio-operate">
        <div className="search-item search-item-date">
          <DateSelect
            lang={getLocale()}
            useNewsTypes={false}
            gameInfo={gameInfo}
            filterOptions={{ time: filterCond?.time }}
            defaultValue={{
              start_time: moment().subtract(6, 'days').format('YYYY-MM-DD'),
              end_time: moment().format('YYYY-MM-DD'),
            }}
            onChange={(timeKey: any, result: any) => {
              if (result?.value?.start_time && result?.value?.end_time) {
                setTimeValue(result?.value);
                !isInit && setIsConfirm(true);
                setIsInit(false);
              }
            }}
          />
        </div>
      </div>
      <StudioTrendingVideo
        language={'origin'}
        filter={filter}
        filterCond={filterCond}
        wholeGameInfo={gameInfo}
      ></StudioTrendingVideo>
      <OpinionHightLight
        translateTopic={translateTopicFunc}
        filter={filter}
        timeValue={timeValue}
        gameInfo={gameInfo}
      />
      <Row className='dhb-studio-opinions-gamestore-community-wrap'>
        <Col span={15}>
          <GameStore filter={useOpinionsFilterConfig(filter, 'GameStore')} isDelay={true}/>
        </Col>
        <Col span={9}>
          <CommunityPerformance filter={filter} isDelay={true}/>
        </Col>
      </Row>
    </div>
  );
}
